import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.preventDefault()

    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.menuTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }
}
